import { Component, Input, OnChanges, SimpleChange } from '@angular/core';
import { SelectableSettings } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { MetadataBaseInfo } from '@gsp-lcm/metadata-selector/metadata/metadata-select/metadatabaseinfo';
import { GSPMetadataService } from '@gsp-lcm/metadata-selector';
import { InternalCommonEntityService } from '../service/internal-common-entity-service';

@Component({
  selector: 'app-common-entity-list',
  templateUrl: './common-entity-list.component.html',
  styleUrls: ['./common-entity-list.component.css']
})
export class CommonEntityListComponent implements OnChanges {
  // åç±»
  @Input() classifier: string;
  // @Input() typeName: string; ä¸éè¦ä¼ éç±»åäºï¼é»è®¤åbeãvoç­
  @Input() filter: string;
  data: MetadataBaseInfo[];
  clear() {
    this.data = [];
  }
  public state: State = {
    skip: 0,
    take: 9999,
    filter: {
      logic: 'and',
      filters: []
    }
  };

  public gridData: GridDataResult;
  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridData = process(this.data, this.state);
  }

  selectableSetting: SelectableSettings = { mode: 'single', checkboxOnly: false };
  constructor(private iceService: InternalCommonEntityService, private gspMetaService: GSPMetadataService) { }
  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    const ceVoList = [];
    for (const key in changes) {
      if (changes.hasOwnProperty(key)) {
        const changedProp = changes[key];
        //é»è®¤å½åå·¥ç¨ä¸çææåæ°æ®
        if (changedProp.currentValue !== undefined && changedProp.currentValue.id === 'default') {
          this.clear();
          //æ¯æbeãvo
          let postfix = this.iceService.postfix;
          this.iceService.getCEList(postfix).subscribe(templates => {
            for (let index = 0; index < templates.length; index++) {
              ceVoList.push(templates[index]);
            }
            this.data = ceVoList;
            this.gridData = process(this.data, this.state);
          });
        } 
        // else if (changedProp.currentValue !== undefined && changedProp.currentValue !== this.typeName &&changedProp.currentValue.desc) 
        else if (changedProp.currentValue !== undefined  &&changedProp.currentValue.desc) 
        {
          this.clear();
          this.gspMetaService.GetDevRootPath().subscribe(root => {
            this.iceService.rootPath = root;
            this.iceService.getCEListByMetadataPkg(changedProp.currentValue.desc, changedProp.currentValue.id).subscribe(ceList => {
              ceList.forEach(element => {
                // if (this.typeName.toLowerCase().indexOf(element.header.type.toLowerCase()) !== -1) {
                ceVoList.push(element);
                // }
              });
              this.data = ceVoList;
              this.gridData = process(this.data, this.state);
            });
          });
        }
      }
    }
  }
  // éä¸­åæ°æ®åçäºä»¶å¤ç
  onSelectionChange(event) {
    if (event.selectedRows.length > 0) {
      const ce = event.selectedRows[0].dataItem;
      const index = this.iceService.metadatas.length;
      // éä¸­çæ¯åæ°æ®å
      if (index > 0) {
        const cacheInfo = this.iceService.metadatas[index - 1];
        cacheInfo.treenode.MetadataInfo.push(ce);
      } else { // éä¸­çæ¯å½åå·¥ç¨
        const treenode = {
          'PackageName': 'default',
          'Version': null,
          'Location': null,
          'MetadataInfo': []
        };
        this.iceService.addMetadata({
          treenode
        });
        this.iceService.metadatas[0].treenode.MetadataInfo.push(ce);
      }
    }
  }
}
